import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { css } from '@emotion/react';
import { alpha, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { ScheduleValue } from '../../../schemas/SourcingList.schema';
import { formatManualSummary, formatSummary, ScheduleSubject } from './schedule';

interface ScheduleSummaryBannerProps {
  readonly schedule: ScheduleValue;
  readonly subjectLabel?: ScheduleSubject;
}

export const ScheduleSummaryBanner: FC<ScheduleSummaryBannerProps> = ({
  schedule,
  subjectLabel = 'query',
}) => {
  const { colors } = useTheme();
  const text = schedule ? formatSummary(schedule, subjectLabel) : formatManualSummary(subjectLabel);

  const bannerCss = css`
    display: flex;
    align-items: center;
    gap: 4px;
    background-color: ${colors.primary[5]};
    border-radius: 4px;
    padding: 16px 12px;
  `;

  return (
    <div css={bannerCss}>
      <ErrorOutlineIcon sx={{ fontSize: 20, color: alpha(colors.neutral[70], 0.64) }} />
      <Typography
        variant='body2'
        color={alpha(colors.primary[100], 0.87)}
        sx={{ lineHeight: 'normal', letterSpacing: '0.17px' }}
      >
        {text}
      </Typography>
    </div>
  );
};
